import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5627dda4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新 增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("汇总")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("工资汇总清单")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("多批工资汇总")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("异动")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("汇总导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("生成凭证")
const _hoisted_9 = {
  class: "el-dropdown-link",
  style: {"cursor":"pointer"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 操作 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("校验")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("公积金")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("部分锁定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("通知员工")
const _hoisted_20 = { class: "mt-10 mb-10" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("锁定/解锁")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tbHead" }, "单位社保", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("生成凭证")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("检查")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount, onDeactivated } from 'vue'
import {useRouter} from "vue-router"
import tbMix, {orgCfig, cpyCfig, userCfig} from '@/global_mixin/tableMixin'
import eptBtn from '@/components/ExportButton.vue'
import { getNumber, formatNumber, exportHandle } from '@/utils/index'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import store from '@/store/index'
// import detailsTable from './ViewsComponents/detailsTable.vue'
import salaryMonth from '@/views/ViewsComponents/salary/salaryTemplate.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'GET/salaries/distributes': fetchList,
  // 新增发放列表
  'POST/salaries/distributes': addDistributesApi,
  // 删除薪酬发放表行
  'DELETE/salaries/distributes/{id}': delDistributesApi,
  // 导出
  'POST/salaries/distributes/export': exportDistributionApi,
  // 锁定 lock： true 已经锁定, false 未锁定
  'PUT/salaries/distributes/{id}/lock': lockApi,
  // 解锁
  'PUT/salaries/distributes/{id}/unlock': unlockApi,
  // 发放清单汇总
  'GET/salaries/distributes/summary': summaryApi,
  // 获取时间内的奖金项目
  'POST/salaries/distributes/reward': getBonusProjectApi,
  // 更新薪酬发放
  'PUT/salaries/distributes/{id}': salariesUpdataApi,
  // 发放清单非整数整 记录
  'GET/salaries/distributes/{id}/check': salariesDistributesIdCheckApi,
  // 发放清单取整
  'GET/salaries/distributes/{id}/rounding': salariesDistributesIdRoundingApi,
  // 发放清单修改
  'POST/salaries/distributes/{id}/confirm': salariesDistributesIdConfirmApi,
  // 更新薪酬发放名称(编辑)
  'PUT/salaries/distributes/name': salariesDistributesNameApi,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 汇总表导出
  'POST/salaries/distributes/summary/export': distributesExportApi,
  // 汇总导出
  'POST/salaries/distributes/export_person': export_personApi,
  // 通知员工确认工资
  'POST/salaries/distributes/{id}/notify/staff': notifyStaffApi,
  // 详情
  'POST/salaries/distributes/{id}': distributesDetailsApi,
  // 发放清单详情锁定解锁
  'PUT/salaries/distributes/detail/locked': lockDetailsApi,
  // 薪酬详情部分锁定
  'PUT/salaries/distributes/detail/batch_locked': batch_lockedApi,
  // 工资汇总清单
  'GET/payroll/summary/query_summary':summaryQuerySummaryApi,
  // 获取财务岗位下拉
  'GET/user_finances': financialJobListApi,
  //  通知员工确认工资 (校验)
  'POST/salaries/distributes/{id}/notify/staff/validate': validateApi,
  // 生成凭证
  'POST/salaries/distributes/generate_voucher':generateVoucherApi
} = Api

let router = useRouter()
let fullUserList: Ref<any[]> = ref([])
let financialJobList: any = ref([])
onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList
  })
  financialJobListApi().then((rep: any) => {
    financialJobList.value = rep.concat([{name: 'null', id: 'null'}])
  })
})
onDeactivated(() => {
  detailFg.value = false
})

const searchConfig: Ref<FromConfig[]> = ref([
  {
    label: '名称',
    value: '',
    upKey: 'name'
  },
  {
    type: "TIME",
    label: "创建时间",
    value: '',
    upKey: 'createdRange',
    upProps: { startKey: 'startDate', endKey: 'endDate', },
    timeCb: (val: string | [], upkey: string) => {
      getBonusProjectApi({
        startDate: val[0],
        endDate: val[1],
      }).then(rep => {
        searchConfig.value[2].options = rep
      })
    },
    props: {
      'value-format': 'YYYY-MM-DD',// 日期格式 （到秒）
      type: 'daterange',
      clearable: true,
      'disabled-date': function(time: any){
        return time.getTime() > Date.now()
      }
    }
  },
  {
    type: 'SELECT',
    label: '项目',
    value: [],
    upKey: 'salaryItems',
    options: [ ],
    props: { clearable: true, multiple: true },
    placeholder: '请选择项目',
    seleProps: {
      label: 'name',
      valueName: 'id',
    }
  },

])

const detailshConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'name'
  },
  orgCfig(),
  // cpyCfig(),
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyIdList",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司", multiple: true, 'collapse-tags': true},
    seleProps: { label: "name", valueName: "id" },
  },
  {
    type: 'SELECT',
    label: '财务岗位',
    value: '',
    upKey: 'position',
    options: financialJobList,
    seleProps: { label: 'name', valueName: 'name', },
    props: { placeholder: '请选择财务岗位', clearable: true }
  },
])

const multipleSelection = ref<any[]>([])
const {
  MI_height, MI_tableData, fetchData, page ,size,
  MI_total, MI_pageChange, MI_sizeChange, MI_identify, MI_params, MI_modifyForm,
} = new tbMix(fetchList)

fetchData()

// 新增
const addFg = ref(false)
const additonConfig: Ref<FromConfig[]> = ref([
  {
    label: '名称',
    value: '',
    upKey: 'name',
    rule:[
      { required: true, message: '必选项', trigger: 'change' },
    ],
  },
  {
    type: "TIME",
    label: "创建时间",
    value: '',
    upKey: 'createdRange',
    rule:[{ required: true, message: '必选项', trigger: 'change' }],
    // upProps: { startKey: 'startDate', endKey: 'endDate', },
    timeCb: (val: string, upkey: string) => {
      getBonusProjectApi({
        // startDate: val[0],
        // endDate: val[1],
        startDate: dayjs(val).startOf('month').format('YYYY-MM-DD'),
        endDate:  dayjs(val).endOf('month').format('YYYY-MM-DD'),
      }).then(rep => {
        additonConfig.value[2].options = rep
      })
    },
    props: {
      'value-format': 'YYYY-MM-DD',// 日期格式 （到秒）
      type: 'month',
      clearable: true,
      'disabled-date': function(time: any){
        return time.getTime() > Date.now()
      }
    }
  },
  {
    type: 'SELECT',
    label: '项目',
    value: [],
    upKey: 'categoryIds',
    options: [ ],
    props: { placeholder: '请选择项目', clearable: true, multiple: true },
    seleProps: {
      label: 'name',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '是否含税',
    value: '',
    upKey: 'tax',
    rule:[{ required: true, message: '请选择是否含税', trigger: 'change' }],
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: {clearable: true, placeholder: '请选择是否含税',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '是否含个人尽孝金',
    value: '',
    upKey: 'filial',
    rule:[{ required: true, message: '请选择是否含个人尽孝金', trigger: 'change' }],
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: {clearable: true, placeholder: '请选择是否含个人尽孝金',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '是否可重复',
    value: '',
    upKey: 'repeat',
    rule:[{ required: true, message: '请选择是否可重复', trigger: 'change' }],
    options: [
      { label: '是', id: true },
      { label: '否', id: false },
    ],
    props: {clearable: true, placeholder: '请选择是否可重复',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  orgCfig(),
  // cpyCfig(),
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司"},
    seleProps: { label: "name", valueName: "id" },
  },
  userCfig({
    upKey: 'userIds',
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px' },
  }),

])
// 新增发放清单
const additonRow = () => {
  MI_modifyForm({}, additonConfig, addFg, async (params: any) => {
    await addDistributesApi({
      ...params,
      startDate: dayjs(params.createdRange).startOf('month').format('YYYY-MM-DD'),
      endDate:  dayjs(params.createdRange).endOf('month').format('YYYY-MM-DD'),
    }, { timeout: 5 * 60000 })
    ElMessage.success('添加成功')
    fetchData(MI_params)
    addFg.value = false
  })
}

// 行详情
const salaryElement: any = ref()
const detailFg = ref(false)
const insureFg = ref(false)
const detailsRow: any = reactive({
  id: ''
})
const showDetail = <T extends object>(row: T) => {
  detailsRow.id= row['id' as keyof T]
  detailFg.value = true
}
const toggleLock = (row: any) => {
  
  salaryElement.value.MI_identify = true
  lockDetailsApi({userId: row.userId, batchId: detailsRow.id}, { contentType: 'formData'}).then(() => {
    ElMessage.success('成功')
    salaryElement.value.MI_identify = false
    salaryElement.value.searchHandle(salaryElement.value.MI_params)
  }).catch(() => {
    salaryElement.value.MI_identify = false
  })
}
const batchToggleLock = () => {
  // 批量切换锁定和解锁
  if(salaryElement.value.selectRows.length === 0){
    ElMessage.warning('请至少选择一跳数据')
    return
  }
  let userIdStr = salaryElement.value.selectRows.map((_user: any) => _user.userId).join(',')
  salaryElement.value.MI_identify = true
  lockDetailsApi({userId: userIdStr, batchId: detailsRow.id}, { contentType: 'formData'}).then(() => {
    ElMessage.success('成功')
    salaryElement.value.MI_identify = false
    salaryElement.value.searchHandle(salaryElement.value.MI_params)
  })
}

// 锁定
const lockHandle = async (row: any) => {
  await lockApi(row)
  ElMessage.success('锁定成功')
  fetchData(MI_params)
}

// 解锁
const unlockHandle = async (row: any) => {
  await unlockApi(row)
  ElMessage.success('解锁成功')
  fetchData(MI_params)
}
// 更新
const upDataHandle = async (row: any) => {
  await ElMessageBox.confirm(
    // '确认更新: ' + row.name + '?',
    '请确认是否更新?',
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  try {
    MI_identify.value = true
    await salariesUpdataApi({id: row.id}, {timeout: 5 * 60000})
    MI_identify.value = false
    ElMessage.success('更新成功')
  } catch (error) {
    MI_identify.value = false
  }
}

// 校验
const userId = ref('')
const checkLoadFg = ref<boolean>(false)
let checkRows: any = ref([])
const handleCheckChange = (rows: any) => {
  checkRows.value = rows
}
let checkData: any = ref([])
const checkFg = ref(false)
let checkOutsideRows: any = {}
const showCheck = async (row: any) =>{
  checkOutsideRows = row
  MI_identify.value = true
  try {
    checkData.value = await salariesDistributesIdCheckApi({id: row.id})
    MI_identify.value = false
    checkFg.value = true
  } catch (error) {
    MI_identify.value = false
  }
}

const showUserCheck = async () => {
  checkLoadFg.value = true
  try {
    checkData.value = await salariesDistributesIdCheckApi({id: checkOutsideRows.id, userId: userId.value})
    checkLoadFg.value = false
  } catch (error) {
    checkLoadFg.value = false
  }
}

const checkHandle = async () => {
  if(checkRows.value.length !== 1){
    ElMessage.warning('请仅选择一条数据')
    return
  }
  // 从后端取整数
  let rep: any = await salariesDistributesIdRoundingApi({id: checkRows.value[0].id})
  ElMessageBox.confirm(
    `基本工资：${rep.basicSalary} <br/> 职位津贴：${rep.jobAllowance} <br/> 年度贡献奖：${rep.postAllowance} <br/> 其他补贴：${rep.otherAllowance} <br/> 公司补助：${rep.companyAllowance} <br/>`,
    '提示',
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  .then(() => {
    return salariesDistributesIdConfirmApi(rep)
  })
  .then(() => {
    ElMessage.success('成功')
    checkFg.value = false
  })
  .catch(() => { })

}

// 汇总
const summaryFg = ref<boolean>(false)
let summaryRow: any = {}
const showSummary = () => {
  if(multipleSelection.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  // summaryRow = row
  summaryFg.value = true
}

const summaruForm: {types: any, items: Array<any>}= reactive({
  types: 'COMPANY',
  items: [],
})

let summaryTbFg = ref<boolean>(false)
let summaryTbData: any = ref([])
const summaryEle: any = ref(null)
const summaryHandle = () => {
  summaryEle.value.validate((valid: boolean) => {
    if(valid){
      summaryTbFg.value = true
      summaryApi({ type: summaruForm.types, ids: multipleSelection.value.map(e => e.id).join(',') })
        .then((rep) => {
          summaryTbData.value = rep
        }).finally(() => {
          summaryTbFg.value = false
        })
    }
  })
}
const summaryCloseHandle = () => {
  summaryTbData.value = []
  summaryRow.vlaue = {}
  summaruForm.types = 'COMPANY'
  summaruForm.items.splice(0)
  
}

// 合计 
const summaryCount = (param: any) => {
    const { columns, data } = param
    const sums: string[] = []
    columns.forEach((column: any, index: number) => {

      if (index === 0) { sums[0] = '合计'; return }

      const values = data.map((item: any) => Number(item[column.property]))

      if (!values.every((value: string | number) => Number.isNaN(value))) {
        sums[index] = getNumber(values.reduce((prev: number, curr: number) => {
          const value = Number(curr)
          if (!Number.isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0))

      } else {
        sums[index] = '-'
      }
    })

  return sums
}

// 导出
const exportFg = ref<boolean>(false)
const exportDetailConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'name'
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: [],
    placeholder: '请选择公司',
    selectFunc: companyApi,
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
    
    props: { placeholder: '请选择公司', clearable: true }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: organizationsApi,
    
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
    props: { placeholder: '请选择团队', clearable: true }
  }
])
const exportDetail = (api: any) => {
  if(multipleSelection.value.length <= 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, exportDetailConfig, exportFg, async (params: object) => {
    ElMessage('开始下载')
    await exportHandle(api, { ...params, distributeIds: multipleSelection.value.map(e => e.id) })
    ElMessage.success('下载成功')
    exportFg.value = false
    /* ElMessage('开始下载')
    let stream: any = await api({ ...params, distributeIds: multipleSelection.value.map(e => e.id) }, {timeout: 60000, responseType: 'blob'})
    let fileName = decodeURI(stream.headers['content-disposition'].split(';')[1].split('filename=')[1])
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    )
    
    let link = document.createElement("a")
    link.style.display = "none"
    link.href = url
    link.setAttribute(
      "download",
      decodeURI(fileName)
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    ElMessage.success('下载成功') */
  })
}
// 汇总导出


// 编辑
const editFg = ref<boolean>(false)
const editConfig = ref([
  {
    label: '名称',
    value: '',
    upKey: 'name',
  },
  {
    type: "TIME",
    label: "财务日期",
    value: '',
    upKey: 'financeMonth',
    props: {
      'value-format': 'YYYY-MM',
      type: 'month',
      clearable: true,
    }
  },
])
const editHandle = (row: any) => {
  MI_modifyForm(row, editConfig, editFg, async (params: object) => {
    await salariesDistributesNameApi({...params, id: row.id} as any, { contentType: 'formData'})
    ElMessage.success('修改成功')
    fetchData(MI_params)
    editFg.value = false
  })

}
// 删除 
const deleteHandle = async (row: any) => {
  await ElMessageBox.confirm(
    '是否删除，将无法恢复',
    '警告',
    {
      type: 'warning',
    }
  )
  MI_identify.value = true
  try {
    await delDistributesApi({id: row.id})
    ElMessage.success('删除成功')
    MI_identify.value = false
    fetchData(MI_params)
  } catch (error) {
    MI_identify.value = false
  }
}
// 通知员工
const isShowNotice = ref<boolean>(false)
const noticeObj = reactive({
  id: '', companyId: [],
})

const showNoticeEmploye = (row: any) => {
  noticeObj.id = row.id
  noticeObj.companyId = []
  isShowNotice.value = true
}
const submitNotice = () => {
  // 通知前校验
  validateApi({companyId: noticeObj.companyId.join(','), id: noticeObj.id}, { contentType: 'formData'}).then((repList: string[]) => {
    // 没有校验异常
    if(repList.length === 0){
      return Promise.resolve()
    }
    // 校验异常确认提醒
    return ElMessageBox.confirm(repList.join('<br>'), '提示', {dangerouslyUseHTMLString: true})
  }).then(() => {
    return notifyStaffApi(noticeObj, { contentType: 'formData'})
  }).then(() => {
    ElMessage.success('通知成功')
    isShowNotice.value = false
    fetchData(MI_params)
  }).catch(() => {

  })
}

// 详情部分锁定
const detailLockFg = ref<boolean>(false)
const detailLockConfig = ref([
  {
    type: 'SELECT',
    label: '类型',
    value: '',
    upKey: 'locked',
    options: [
      { label: '锁定', id: true },
      { label: '解锁', id: false },
    ],
    rule: [{ required: true, message: '请选择类别', trigger: 'change' }],
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择类别', clearable: false }
  },
  orgCfig(),
  // cpyCfig(),
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司"},
    seleProps: { label: "name", valueName: "id" },
  },
])
const detailLockHandle = (row: any) => {
  MI_modifyForm({}, detailLockConfig, detailLockFg, async(params: any) => {
    if(!params.orgId && !params.companyId){
      ElMessage.warning('公司和团队不能都为空')
      return
    }
    await batch_lockedApi({batchId: row.id, ...params}, { contentType: 'formData'})
    ElMessage.success('成功')
    detailLockFg.value = false
  })
}


// 跳转工资汇总表
const switchSummaryPage = () => {
  if(multipleSelection.value.length !== 1){
    ElMessage.warning('请选择一条数据')
    return
  }

  // multi: 是否多批工资汇总
  router.push({
    name: 'SalarySummary',
    params: {
      distributeId: multipleSelection.value[0].id,
      name: multipleSelection.value[0].name,
      multi: 'singleSmy'

    }
  })
}

// 多批次汇总
const switchSummarysPage = () => {
  if(multipleSelection.value.length <= 1){
    ElMessage.warning('请选择多条数据')
    return
  }
  router.push({
    name: 'SalarySummary',
    params: {
      distributeId: '0',
      name: '汇总:' + multipleSelection.value.map(e => e.name),
      distributeIdList: multipleSelection.value.map(e => e.id),
      multi: 'mulSmy'
    }
  })
}
// 生成凭证
const createVoucherHandle=async (isMultiple:boolean=false)=>{
  if(!isMultiple&&(multipleSelection.value.length!==1)){ 
    let message=multipleSelection.value.length?'单次只能对一条数据进行操作':'请先勾选数据'
    ElMessage.warning(message)
    return  
  }
  let result=await ElMessageBox.confirm('是否生成相应数据的凭证',{confirmButtonText:'确定',cancelButtonText:'取消'})
  if(!result) return
  let data:any=multipleSelection.value[0]
  let params=!isMultiple?{
    distributeId:data.id,
    voucherSource:'DISTRIBUTION_SALARY',
    startDate:data.startDate,
    endDate:data.endDate
  }:{
    type:summaruForm.types,
    ids:multipleSelection.value.map((el:any)=>el.id),
    voucherSource:'ACCRUAL_SALARY'
  }
  generateVoucherApi(params).then((res:any)=>{
    ElMessage.success('操作成功')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_expand = _resolveComponent("expand")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "发放清单" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              title: true,
              searchConfig: searchConfig.value
            }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (additonRow()))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (showSummary()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (switchSummaryPage())),
      type: "info"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (switchSummarysPage())),
      type: "info"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'distributionCompare'})))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (exportDetail(_unref(exportDistributionApi))))
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[6] || (_cache[6] = ($event: any) => (exportDetail(_unref(export_personApi))))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[7] || (_cache[7] = ($event: any) => (createVoucherHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      class: "mt-10",
      style: {"width":"970px"},
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px',
      onSelectionChange: _cache[8] || (_cache[8] = (rows) => { multipleSelection.value = rows })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "名称(点击查看详情)",
          prop: "name",
          width: "160",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (showDetail(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id"
        }),
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          prop: "startDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          prop: "endDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "财务日期",
          prop: "financeMonth"
        }),
        _createVNode(_component_el_table_column, {
          label: "条数",
          prop: "num",
          align: "right"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_dropdown, { trigger: "click" }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (editHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    (!row.locked)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (upDataHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (!row.locked)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (lockHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (row.locked)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (unlockHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (!row.locked)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (showCheck( row ))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (_ctx.$router.push({ name: 'distributionFundCheck', params: { id: row.id } }))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (detailLockHandle( row ))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    (!row.locked)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 4 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              type: "danger",
                              onClick: ($event: any) => (deleteHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (showNoticeEmploye(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 2
            }, 1024)), [
              [_directive_permission, 'Write']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      style: {"float":"none"},
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addFg).value = $event)),
      title: "新增",
      draggable: "",
      width: "880px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "选择员工后，公司和团队筛选将会失效",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: additonConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "详情",
      modelValue: detailFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((detailFg).value = $event)),
      fullscreen: true
    }, {
      default: _withCtx(() => [
        (detailFg.value)
          ? (_openBlock(), _createBlock(salaryMonth, {
              key: 0,
              ref_key: "salaryElement",
              ref: salaryElement,
              "basic-api": _unref(distributesDetailsApi),
              "basic-params": _unref(detailsRow),
              "basic-search-config": detailshConfig.value
            }, {
              buttonArea: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "primary",
                    onClick: batchToggleLock
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'Write']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    loading: _unref(MI_identify),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (upDataHandle({id: _unref(detailsRow).id})))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }, 8, ["loading"])), [
                    [_directive_permission, 'Write']
                  ])
                ])
              ]),
              columnHead: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  label: "员工",
                  prop: "userName",
                  fixed: "",
                  width: "130",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.userName + ' (' + row.alias + ')'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "财务岗位",
                  prop: "position",
                  width: "100"
                })
              ]),
              columnEnd: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "单位社保" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_el_icon, {
                        class: "column-icon",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (insureFg.value = !insureFg.value))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_expand)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "总计",
                      prop: "companySocialSecurity",
                      width: "120"
                    }, null, 8, ["formatter"]),
                    (insureFg.value)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: "Details"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位养老保险",
                              prop: "companyEndowment",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位医疗保险",
                              prop: "companyMedical",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位工伤保险",
                              prop: "companyInjury",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位生育保险",
                              prop: "companyMaternity",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位失业保险",
                              prop: "companyUnemployment",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位公积金",
                              prop: "companyHousing",
                              width: "120"
                            }, null, 8, ["formatter"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right"
                }, {
                  default: _withCtx(({row}) => [
                    (row.locked === false)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (toggleLock(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ])
                      : _createCommentVNode("", true),
                    (row.locked === true)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          key: 1,
                          type: "danger",
                          onClick: ($event: any) => (toggleLock(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["basic-api", "basic-params", "basic-search-config"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "汇总",
      top: "70px",
      draggable: "",
      modelValue: summaryFg.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((summaryFg).value = $event)),
      width: "85%",
      onClose: summaryCloseHandle
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = ($event: any) => (summaryFg.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(summaruForm),
          inline: "",
          ref_key: "summaryEle",
          ref: summaryEle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "types",
              rules: [{ required: true, message: '请选择类型', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(summaruForm).types,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(summaruForm).types) = $event)),
                  "value-key": "label",
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_isRef(summaryTbData) //@ts-ignore
 ? summaryTbData.value = [] : summaryTbData = []))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "公司",
                      value: "COMPANY"
                    }),
                    _createVNode(_component_el_option, {
                      label: "团队",
                      value: "ORG"
                    }),
                    _createVNode(_component_el_option, {
                      label: "所有",
                      value: "ALL"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "类型项" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(summaruForm).items,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(summaruForm).items) = $event)),
                  multiple: "",
                  "collapse-tags": "",
                  "value-key": "label"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "考勤",
                      value: {label: '考勤合计', prop: 'sumAttendance'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "提成",
                      value: {label: '提成合计', prop: 'sumCommission'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "福利",
                      value: {label: '福利合计', prop: 'sumWelfare'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "奖金",
                      value: {label: '奖金合计', prop: 'sumBonus'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他合计",
                      value: {label: '其他合计', prop: 'sumOther'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "固定工资合计",
                      value: {label: '固定工资合计', prop: 'sumSalary'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "应发合计",
                      value: {label: '应发合计', prop: 'sumTotalSalary'}
                    }),
                    _createVNode(_component_el_option, {
                      label: "五险一金合计",
                      value: {label: '单位五险一金合计', prop: 'sumCompanySocialSecurity'}
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: summaryHandle
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }),
        _createVNode(eptBtn, {
          type: "primary",
          exportFn: _unref(distributesExportApi),
          exportText: '导出',
          exportParam: {
        type: _unref(summaruForm).types, 
        titles: _unref(summaruForm).items.map(e => e.label), 
        ids: multipleSelection.value.map(e => e.id)
      }
        }, null, 8, ["exportFn", "exportParam"]),
        _createVNode(_component_el_button, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (createVoucherHandle(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "mt-10",
          border: "",
          data: _unref(summaryTbData),
          "show-summary": "",
          "row-key": "uuid",
          "summary-method": summaryCount,
          "max-height": "630px"
        }, {
          default: _withCtx(() => [
            (['ALL', 'COMPANY'].includes(_unref(summaruForm).types))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "公司",
                  prop: "companyName",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            (['ALL', 'ORG'].includes(_unref(summaruForm).types))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: "团队",
                  prop: "orgName"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              label: "财务岗位",
              prop: "financialPosition"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaruForm).items, (item) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                label: item.label,
                prop: item.prop,
                align: "right",
                formatter: _unref(formatNumber),
                key: item.label
              }, null, 8, ["label", "prop", "formatter"]))
            }), 128)),
            (_unref(summaruForm).items.find((e) => e.prop === 'sumCompanySocialSecurity'))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  label: "五险一金详情"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "单位养老保险",
                      prop: "sumCompanyEndowment",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "单位医疗保险",
                      prop: "sumCompanyMedical",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "单位工伤保险",
                      prop: "sumCompanyInjury",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "单位生育保险",
                      prop: "sumCompanyMaternity",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "单位失业保险",
                      prop: "sumCompanyUnemployment",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "单位公积金",
                      prop: "sumCompanyHousing",
                      align: "right",
                      formatter: _unref(formatNumber)
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(summaryTbFg)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: exportFg.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((exportFg).value = $event)),
      title: "导出"
    }, {
      default: _withCtx(() => [
        (exportFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: exportDetailConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "校验",
      draggable: "",
      modelValue: checkFg.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((checkFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "mb-10",
          onClick: checkHandle
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: userId.value,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((userId).value = $event)),
          placeholder: "请选择员工",
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullUserList), (_user) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: _user.userId,
                label: _user.realName + '(' + _user.username + ')',
                value: _user.userId
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          class: "ml-10",
          type: "primary",
          onClick: showUserCheck
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          class: "mt-10",
          data: _unref(checkData),
          "max-height": "500",
          onSelectionChange: handleCheckChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "userName"
            }),
            _createVNode(_component_el_table_column, {
              label: "英文名",
              prop: "alias",
              width: "125"
            }),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "基本工资",
              prop: "salary"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "职位津贴",
              prop: "jobAllowance"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "年度贡献奖",
              prop: "postAllowance"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "其他补贴",
              prop: "otherAllowance"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "公司补助",
              prop: "companyAllowance"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "军阶奖",
              prop: "rankAllowance"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, checkLoadFg.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      width: "30%",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: editConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "500px",
      modelValue: isShowNotice.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((isShowNotice).value = $event)),
      title: "通知员工"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[26] || (_cache[26] = ($event: any) => (isShowNotice.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (submitNotice())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(noticeObj),
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "公司:",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(noticeObj).companyId,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(noticeObj).companyId) = $event)),
                  style: {"width":"310px"},
                  multiple: "",
                  "collapse-tags": "",
                  placeholder: "请选择公司"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.id,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "详情部分锁定",
      modelValue: detailLockFg.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((detailLockFg).value = $event))
    }, {
      default: _withCtx(() => [
        (detailLockFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
      searchConfig: detailLockConfig.value,
      submitText: '确定'
    })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})